import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

const NewNote = props => {
  const {
    newNoteText,
    noteStatus,
    newNoteError,
    cleanAddInput,
    createNewNote,
    setNewNoteText
  } = props;

  const maxChar = 255;
  const textMaxChar = "Inserire max " + maxChar + " caratteri.";

  let errorClass = newNoteError ? "errorInput" : "";

  const intl = useIntl();

  return (
    <div>
      <TextArea
        autoSize={{ minRows: 2, maxRows: 6 }}
        autoFocus
        className={errorClass}
        id={"newNote"}
        value={newNoteText}
        size="large"
        placeholder={intl.formatMessage({ id: "actions.addComment" })}
        onChange={e => setNewNoteText(e.target.value)}
        style={{ margin: "20px 0" }}
      />
      <div
        style={{ marginTop: "-10px", marginBottom: "10px", color: "#D82829" }}
      >
        {newNoteError}
        <div
          style={{
            marginTop: "-10px",
            marginBottom: "10px",
            color: "#D82829"
          }}
        >
          {newNoteText &&
          newNoteText.trim().length > maxChar
            ? textMaxChar
            : null}
        </div>
      </div>

      {noteStatus && noteStatus.started ? (
        <div style={{ textAlign: "center" }}>
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ fontSize: "24px", color: "#2084c2" }}
          />
        </div>
      ) : (
        <div>
          <Button
            className="gs-documents-detail-note-add"
            onClick={() => createNewNote()}
            style={{ width: "calc(51% - 7px)", marginRight: "10px" }}
          >
            <FormattedMessage id="actions.insert" />
          </Button>
          <Button
            kind={"secondary"}
            colorScheme={"ghost"}
            onClick={() => cleanAddInput()}
            style={{ width: "calc(49% - 7px)" }}
          >
            <FormattedMessage id="actions.cancel" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default NewNote;
